import { render, staticRenderFns } from "./section-quotes.vue?vue&type=template&id=0505baf2"
import script from "./section-quotes.vue?vue&type=script&lang=js"
export * from "./section-quotes.vue?vue&type=script&lang=js"
import style0 from "./section-quotes.vue?vue&type=style&index=0&id=0505baf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports